"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formTypes = void 0;
exports.formTypes = {
    ebook: 'ebook',
    webinar: 'webinar',
    webinar_es: 'webinar_form_es',
    webinar_it: 'webinar_form_it',
    hero_form: 'hero_form',
    hero_form_it: 'hero_form_it',
    hero_form_de: 'hero_form_de',
    hero_form_es: 'hero_form_es',
    newsletter: 'newsletter',
    meetup: 'meetup'
};
